import { AxiosError } from "axios";
import { all, call, put, takeLatest } from "redux-saga/effects";
import studentProfileDetails from "./service";
import {
  ALLOCATE_PLA_REQUEST,
  DEFER_SLP_REQUEST,
  GET_AUDIT_TRAIL_LIST_REQUEST,
  GET_CONTACT_NOTE_REQUEST,
  DELETE_COMPLETED_SLP_REQUEST,
  GET_COMPLETED_SLP_DETAILS_REQUEST,
  NEXT_OR_CURRENT_SLP_REQUEST,
  GET_ALL_SLP_GOALS_AND_ASSESSMENT_REQUEST,
  UPDATE_CONTACT_DATE_REQUEST,
} from "./actionTypes";
import {
  allocatePLAFailure,
  allocatePLASuccess,
  deferSLPFailure,
  deferSLPSuccess,
  getAuditTrailFailure,
  getAuditTrailListSuccess,
  getContactNoteFailure,
  getContactNoteSuccess,
  deleteCompletedSLPFailure,
  deleteCompletedSLPSuccess,
  getCompletedSLPDetailsFailure,
  getCompletedSLPDetailsSuccess,
  nextOrCurrentSLPFailure,
  nextOrCurrentSLPSuccess,
  getAllSLPGoalsAndAssessmentSuccess,
  getAllSLPGoalsAndAssessmentFailure,
  updateContactDateSuccess,
  updateContactDateFailure,
} from "./actions";
import {
  AllocatePLARequest,
  AllocatePLASuccessPayload,
  CompletedSLPDetailsResponse,
  DeferSLPRequest,
  DeferSLPResponse,
  GetAuditTrailListRequest,
  GetAuditTrailListResponse,
  GetContactNoteRequest,
  GetContactNoteResponse,
  DeleteCompletedSLPRequest,
  DeleteCompletedSLPSuccessPayload,
  GetCompletedSLPDetailsRequest,
  NextOrCurrentSLPRequest,
  NextOrCurrentSLPResponse,
  GetAllSLPGoalsAndAssessmentRequest,
  GetAllSLPGoalsAndAssessmentResponse,
  UpdateContactDateRequest,
  IUpdateContactDateRequestPayloadValues,
  IUpdateContactDateSuccessPayload,
} from "./types";

function* nextOrCurrentSLPSaga(action: NextOrCurrentSLPRequest) {
  try {
    const payload = {
      id: action.payload.values.id,
    };

    const response: NextOrCurrentSLPResponse = yield call(
      studentProfileDetails.getNextOrCurrentSLP,
      payload
    );

    yield put(
      nextOrCurrentSLPSuccess({
        slpDetails: response.item,
      })
    );
    action.payload.callback({
      slpDetails: response.item,
    });
  } catch (e) {
    yield put(
      nextOrCurrentSLPFailure({
        error: (e as AxiosError).message,
      })
    );
  }
}

function* deferSLPSaga(action: DeferSLPRequest) {
  try {
    const payload = {
      slpId: action.payload.values.slpId,
      dueDate: action.payload.values.dueDate,
    };

    const response: DeferSLPResponse = yield call(
      studentProfileDetails.deferSLP,
      payload
    );

    yield put(
      deferSLPSuccess({
        deferSLPDetails: response.item,
      })
    );
    action.payload.callback({
      deferSLPDetails: response.item,
    });
  } catch (e) {
    yield put(
      deferSLPFailure({
        error: (e as AxiosError).message,
      })
    );
  }
}

function* allocatePLASaga(action: AllocatePLARequest) {
  try {
    const payload = {
      slpId: action.payload.values.slpId,
      dueDate: action.payload.values.dueDate,
      plaId: action.payload.values.plaId,
    };

    const response: AllocatePLASuccessPayload = yield call(
      studentProfileDetails.allocatePLA,
      payload
    );

    yield put(
      allocatePLASuccess({
        isSuccessStatusCode: response.isSuccessStatusCode,
      })
    );
    action.payload.callback({
      isSuccessStatusCode: response.isSuccessStatusCode,
    });
  } catch (e) {
    yield put(
      allocatePLAFailure({
        error: (e as AxiosError).message,
      })
    );
  }
}

function* getContactNoteSaga(action: GetContactNoteRequest) {
  try {
    const response: GetContactNoteResponse = yield call(
      studentProfileDetails.getContactNote,
      {
        sLPId: action.payload.values.sLPId,
      }
    );

    yield put(
      getContactNoteSuccess({
        item: response?.item,
      })
    );
    action.payload.callback({
      item: response.item,
    });
  } catch (e) {
    yield put(
      getContactNoteFailure({
        error: (e as AxiosError).message,
      })
    );
  }
}

function* getAuditTrailListSaga(action: GetAuditTrailListRequest) {
  try {
    const response: GetAuditTrailListResponse = yield call(
      studentProfileDetails.getAuditTrailList,
      {
        studentId: action.payload.values.studentId,
      }
    );
    yield put(
      getAuditTrailListSuccess({
        auditTrailList: response.item,
      })
    );
    action.payload.callback({
      auditTrailList: response.item,
    });
  } catch (e) {
    yield put(
      getAuditTrailFailure({
        error: (e as AxiosError).message,
      })
    );
  }
}

function* deleteCompletedSLPSaga(action: DeleteCompletedSLPRequest) {
  try {
    const payload = {
      id: action.payload.values.id,
    };

    const response: DeleteCompletedSLPSuccessPayload = yield call(
      studentProfileDetails.deleteCompletedSLP,
      payload
    );

    yield put(
      deleteCompletedSLPSuccess({
        isSuccessStatusCode: response.isSuccessStatusCode,
      })
    );
    action.payload.callback({
      isSuccessStatusCode: response.isSuccessStatusCode,
    });
  } catch (e) {
    yield put(
      deleteCompletedSLPFailure({
        error: (e as AxiosError).message,
      })
    );
  }
}

function* getCompletedSLPDetailsSaga(action: GetCompletedSLPDetailsRequest) {
  try {
    const payload = {
      id: action.payload.values.id,
    };

    const response: CompletedSLPDetailsResponse = yield call(
      studentProfileDetails.getCompletedSLPDetails,
      payload
    );

    yield put(
      getCompletedSLPDetailsSuccess({
        completedSLPDetails: response.item,
      })
    );
    action.payload.callback({
      completedSLPDetails: response.item,
    });
  } catch (e) {
    yield put(
      getCompletedSLPDetailsFailure({
        error: (e as AxiosError).message,
      })
    );
  }
}

function* getAllSLPGoalsAndAssessmentSaga(
  action: GetAllSLPGoalsAndAssessmentRequest
) {
  try {
    const response: GetAllSLPGoalsAndAssessmentResponse = yield call(
      studentProfileDetails.getAllSLPGoalsAndAssessment,
      action.payload.values
    );

    const paginationDetails = {
      nextPage: response.item.nextPage,
      prevPage: response.item.prevPage,
      totalCount: response.item.totalRecordCount,
      totalPages: response.item.pageCount,
    };

    yield put(
      getAllSLPGoalsAndAssessmentSuccess({
        groupedList: response.item.records,
        groupedListPagination: paginationDetails,
      })
    );
    action.payload.callback({
      groupedList: response.item.records,
      groupedListPagination: paginationDetails,
    });
  } catch (error) {
    yield put(
      getAllSLPGoalsAndAssessmentFailure({
        error: (error as AxiosError).message,
      })
    );
  }
}

function* updateContactDateSaga(action: UpdateContactDateRequest) {
  try {
    const payload: IUpdateContactDateRequestPayloadValues =
      action.payload.values;

    const response: IUpdateContactDateSuccessPayload = yield call(
      studentProfileDetails.updateContactDate,
      payload
    );

    yield put(
      updateContactDateSuccess({
        isSuccessStatusCode: response.isSuccessStatusCode,
      })
    );
    action.payload.callback({
      isSuccessStatusCode: response.isSuccessStatusCode,
    });
  } catch (e) {
    yield put(
      updateContactDateFailure({
        error: (e as AxiosError).message,
      })
    );
  }
}

function* studentProfileDetailsSaga() {
  yield all([takeLatest(NEXT_OR_CURRENT_SLP_REQUEST, nextOrCurrentSLPSaga)]);
  yield all([takeLatest(DEFER_SLP_REQUEST, deferSLPSaga)]);
  yield all([takeLatest(ALLOCATE_PLA_REQUEST, allocatePLASaga)]);
  yield all([takeLatest(GET_CONTACT_NOTE_REQUEST, getContactNoteSaga)]);
  yield all([takeLatest(GET_AUDIT_TRAIL_LIST_REQUEST, getAuditTrailListSaga)]);
  yield all([takeLatest(DELETE_COMPLETED_SLP_REQUEST, deleteCompletedSLPSaga)]);
  yield all([
    takeLatest(GET_COMPLETED_SLP_DETAILS_REQUEST, getCompletedSLPDetailsSaga),
  ]);
  yield all([
    takeLatest(
      GET_ALL_SLP_GOALS_AND_ASSESSMENT_REQUEST,
      getAllSLPGoalsAndAssessmentSaga
    ),
  ]);
  yield all([takeLatest(UPDATE_CONTACT_DATE_REQUEST, updateContactDateSaga)]);
}

export default studentProfileDetailsSaga;
